import React from 'react'
import styled from '@emotion/styled'
import { font, spacing } from '@mobi/component-library/Theme/Common'
import noContentCard from './assets/noContentCard.png'
import noContentCard2 from './assets/noContentCard2.png'

export const EmptyTipsMessage: React.FC<{
  card?: 'noContentCard' | 'noContentCard2'
  title?: string
  description?: string
}> = ({
  card = 'noContentCard',
  title = 'No Shared Tips',
  description = 'No tips shared at the moment, check back later or refresh the page',
}) => {
  return (
    <WrapperStyled>
      <img
        src={card === 'noContentCard' ? noContentCard : noContentCard2}
        alt='Profile Tips Page Empty'
        width='231'
        height='135'
      />

      <div>{title}</div>

      <div>{description}</div>
    </WrapperStyled>
  )
}

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  paddingTop: spacing.huge,

  '> div:first-of-type': {
    marginTop: spacing.big,
    fontWeight: font.weight.semibold,
  },
  
  '> div:last-of-type': {
    maxWidth: '25rem',
  },
})
